import { LangText } from '@/components';
import OutLink from '@/components/OutLink';
import { VIP_URL } from '@/constants';
import { PlatformEnum } from '@/service/api/types';
import { preFixImgUrl } from '@/utils';

const VIP_BG_IMG = preFixImgUrl('b0842851af843bfc2067a6aa9f829d03.png');

const VIP_CARDS = [
  {
    index: '01',
    titleKey: 'home.vip.cards.wako.title',
    descKey: 'home.vip.cards.wako.desc',
    actionKey: 'home.vip.cards.wako.action',
    active: true,
    icon: preFixImgUrl('9ed6589f7c60e4f8b34ffb71df0125d9.png'),
  },
  {
    index: '02',
    titleKey: 'home.vip.cards.fufu.title',
    descKey: 'home.vip.cards.fufu.desc',
    actionKey: 'common.status.stayTuned',
    active: false,
    icon: preFixImgUrl('061559162337e02df5d709423491ea3d.png'),
  },
  {
    index: '03',
    titleKey: 'home.vip.cards.kansaiReception.title',
    descKey: 'home.vip.cards.kansaiReception.desc',
    actionKey: 'common.status.stayTuned',
    active: false,
    icon: preFixImgUrl('de257497f9206ae0eed147245773b46f.png'),
  },
] as const;

const SectionTitle = () => {
  return (
    <div className="flex flex-col items-center">
      <LangText lngKey="home.vip.premiumTitle" className="text-[36px] font-bold leading-[50px] text-[#000]" />
      <LangText lngKey="home.vip.title" className="text-[36px] font-bold leading-[50px] text-[#000]" />
      <span className="mt-[22px] h-[4px] w-[108px] rounded-full bg-primary" />
    </div>
  );
};

const VipCard = ({ item }: { item: typeof VIP_CARDS[number] }) => {
  const actionButton = (
    <button
      type="button"
      className={`mt-[22px] h-[24px] rounded-full px-[12px] text-[12px] justify-center items-center transition-opacity hover:opacity-90 ${
        item.active
          ? 'cursor-pointer bg-primary text-white'
          : 'cursor-not-allowed border border-primary bg-secondary text-primary'
      }`}
    >
      <LangText lngKey={item.actionKey} />
    </button>
  );

  return (
    <div className="relative h-[138px] flex-1 overflow-hidden rounded-[16px] bg-white px-[40px] py-[25px]">
      <div className="relative z-10">
        <LangText lngKey={item.titleKey} className="block text-[16px] font-bold leading-[22px] text-[#000]" />
        <LangText lngKey={item.descKey} className="mt-[4px] block text-[12px] leading-[18px] text-primary" />
        {item.active ? (
          <OutLink platform={PlatformEnum.VIP} linUrl={VIP_URL}>
            {actionButton}
          </OutLink>
        ) : (
          actionButton
        )}
      </div>
      <img
        src={item.icon}
        alt=""
        className="pointer-events-none absolute right-[20px] top-[0px] z-10 h-auto w-[132px] object-contain"
        draggable={false}
      />
    </div>
  );
};

export const VipReservation = () => {
  return (
    <section className="mx-auto w-[1200px] pt-[96px]">
      <SectionTitle />
      <div
        className="mt-[74px] h-[366px] overflow-hidden rounded-[20px] bg-cover bg-center bg-no-repeat px-[42px] pt-[35px]"
        style={{ backgroundImage: `url(${VIP_BG_IMG})` }}
      >
        <div className="inline-flex h-[30px] items-center rounded-full bg-black/30 px-[16px]">
          <LangText lngKey="home.vip.badge" className="text-[14px] font-bold text-white/80" />
        </div>
        <LangText lngKey="home.vip.heroTitle" className="mt-[22px] block text-[30px] font-bold leading-[42px] text-white" />
        <LangText lngKey="home.vip.heroSubtitle" className="mt-[8px] block text-[20px] leading-[28px] text-white" />
        <div className="mt-[22px] flex gap-[18px]">
          {VIP_CARDS.map((item) => (
            <VipCard key={item.index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
